import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import DatePicker from "react-multi-date-picker"
import moment from 'moment'
import Handler from '../../../Helpers/Handler'
import { useParams } from 'react-router-dom'
import { randomId, reloadWindowToPath } from '../../../Helpers/Utils'
import { FaCloudUploadAlt, FaPlus } from 'react-icons/fa'
import { ImCross } from 'react-icons/im'
import { BsFillPatchCheckFill } from 'react-icons/bs'

const ImageUpload = () => {
    const { id } = useParams()
    const [imageTemp, setImageTemp] = useState([])
    const [disableButton, setDisableButton] = useState(false)
    const imageChange = (e) => {
        const imageDatas = Object?.values(e.target.files)
        if (imageDatas && imageDatas?.length !== 0) {
            imageDatas?.map((value) => {
                if (value?.size <= 10000000) {
                    setImageTemp((prev) => {
                        return [
                            ...prev,
                            {
                                imgId: randomId(),
                                file: value,
                                url: URL.createObjectURL(value)
                            }
                        ]
                    })
                } else {
                    toast?.error(`Image Must to be below 10 MB`)
                }
            })
        } else {
            toast?.error("kindly select correct images")
        }
    };
    const cancelImage = (imgId) => setImageTemp(imageTemp?.filter((value) => { return value?.imgId !== imgId }))
    const submitImage = async () => {
        if (!imageTemp?.length || imageTemp?.length < 1) {
            toast.error("Upload 1 image")
            return
        }
        setDisableButton(true)
        const formData = new FormData()
        imageTemp?.forEach((value) => {
            formData?.append("car", value?.file)
        })
        const response = await Handler({ method: 'patch', url: `/staff/car/carImages/${id}`, data: formData, formdata: true })
        if (response?.success) {
            toast?.success("Image is Uploaded Successfully")
            setTimeout(() => {
                reloadWindowToPath(`/car/details/${id}`)
            }, 1500);
        } else {
            setDisableButton(false)
            toast.error(response?.data?.message);
        }
    }
    useEffect(() => {
        if (imageTemp?.length > 10) setImageTemp(imageTemp.slice(0, 10))
    }, [imageTemp])

    return (
        <React.Fragment>
            <div className='justify-content-center align-items-center row mx-3'>
                <div className='image-add-card'>
                    {
                        imageTemp && imageTemp?.length !== 0 &&
                        imageTemp?.map((value, i) => {
                            if (i < 10) {
                                return (
                                    <div className='image-view-box' key={value?.imgId}>
                                        <span className='cancel-image' onClick={() => cancelImage(value?.imgId)} ><ImCross /></span>
                                        <span ><img src={value?.url} alt={value?.imgId} /></span>
                                    </div>
                                )
                            }
                        })
                    }

                    {
                        imageTemp && imageTemp?.length < 10 &&
                        <div className='image-box' ><input autoComplete='off' disabled={disableButton} onChange={imageChange} type='file' multiple="multiple" accept="image/png,image/jpeg" /> <FaPlus /></div>
                    }
                </div>
            </div>

            <div className="d-flex align-items-center justify-content-center mt-3 pb-0">
                <button className='btn-success btn' disabled={disableButton} onClick={submitImage} >Submit</button>
            </div>
        </React.Fragment>
    )
}

export default ImageUpload